module.exports = __webpack_public_path__ + "sandwichboard_border-9b00024a0b68a28568af2d570ac2d88e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/sandwichboard_border.png
// module id = 1584
// module chunks = 1